import { Button, DatePicker, Input, Radio, Select, Table } from "antd";
import { feedAndCommentClaimColumns, filterFeedHiddenSearchCategoryOptions, filterFeedHiddenStatusOptions, useGetAllFeedAndCommentClaimAdmin } from "./model"
import dayjs from "dayjs";
import { InlineContent } from "../../../components/Shared";
import { useEffect, useState } from "react";

const FeedAndCommentClaimManage = () => {
    const dateMap = {
        today: JSON.stringify([dayjs().startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
        week: JSON.stringify([dayjs().add(-7, 'd').startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
        month: JSON.stringify([dayjs().add(-30, 'd').startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
    }
    const [filterDateList, setFilterDateList] = useState<'all' | string[]>('all')
    const [filterFeedHiddenStatusList, setFilterFeedHiddenStatusList] = useState<string[]>(['all']);
    const [filterSearch, setFilterSearch] = useState<string>('')
    const [filterSearchCategory, setFilterSearchCategory] = useState<TFeedAndCommentClaimSearchCategory>('claimNickName');
    const [filterType, setFilterType] = useState<'all' | 'feed' | 'feedComment'>('all');
    const [feedAndCommentClaimList, setFeedAndCommentClaimList] = useState<IFeedAndCommentClaimAdminResponse[]>([]);
    const responseQuery = 'claimId status claimDateTime claimNickName creatorNickName content targetId targetType category hiddenLastUpdatedTime hiddenMemberName feedId';
    const { data, isLoading, isSuccess } = useGetAllFeedAndCommentClaimAdmin<IFeedAndCommentClaimAdminResponse[]>(responseQuery)

    const onFilterDataList = () => {
        if (!data) return;
        const fillterdData = data.filter(q =>
            (filterDateList === 'all' || (!dayjs(filterDateList[0]).startOf('d').isAfter(dayjs(q.claimDateTime)) && !dayjs(filterDateList[1]).endOf('d').isBefore(dayjs(q.claimDateTime)))) &&
            (filterFeedHiddenStatusList.includes('all') || (filterFeedHiddenStatusList.includes(String(q.status)))) &&
            (filterSearchCategory === 'claimNickName'
                ? (q.claimNickName).includes(filterSearch)
                : filterSearchCategory === 'creatorNickName'
                    ? (q.creatorNickName).includes(filterSearch)
                    : filterSearchCategory === 'content'
                        ? (q.content).includes(filterSearch)
                        : filterSearchCategory === 'targetId'
                            ? (Number(q.targetId) === Number(filterSearch))
                            : true) &&
            (filterType === 'all' || (filterType === q.targetType)))
            .sort((a, b) => dayjs(b.claimDateTime).diff(dayjs(a.claimDateTime)))
            .map((q, _, arr) => ({ ...q, totalClaimCnt: arr.filter(w => w.targetId === q.targetId && w.targetType === q.targetType).length }))

        setFeedAndCommentClaimList(fillterdData)
    }

    useEffect(() => {
        if (!isSuccess) return
        onFilterDataList()
    }, [isSuccess, filterDateList, filterFeedHiddenStatusList, filterSearch, filterSearchCategory, filterType])

    return <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '32px' }}>
            <InlineContent title="처리 상태" content={<Select mode='multiple' defaultValue={filterFeedHiddenStatusList} value={filterFeedHiddenStatusList} onChange={q => setFilterFeedHiddenStatusList(q)} options={filterFeedHiddenStatusOptions} style={{ width: '30%' }} />} />

            <InlineContent title="신고일시" content={<div>
                <div style={{ display: "flex", gap: "16px", flex: 3, }}>
                    <Radio.Group
                        optionType="button"
                        value={filterDateList === 'all' ? filterDateList : JSON.stringify(filterDateList)}
                        onChange={(q) => setFilterDateList(q.target.value === 'all' ? q.target.value : JSON.parse(q.target.value))}
                    >
                        <Radio value={'all'}>전체</Radio>
                        <Radio value={dateMap['today']}>오늘</Radio>
                        <Radio value={dateMap['week']}>7일</Radio>
                        <Radio value={dateMap['month']}>1개월</Radio>
                    </Radio.Group>
                    <DatePicker.RangePicker
                        allowClear={false}
                        value={filterDateList === 'all' ? undefined : [dayjs(filterDateList[0]), dayjs(filterDateList[1])]}
                        onChange={(dates) => setFilterDateList(dates && dates[0] && dates[1] ? [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')] : 'all')}
                    />
                </div>
            </div>} />

            <InlineContent title="검색" content={<div style={{ display: "flex", gap: "16px", flex: 3, }}>
                <Select defaultValue={filterSearchCategory} value={filterSearchCategory} onChange={q => setFilterSearchCategory(q)} options={filterFeedHiddenSearchCategoryOptions} />
                <Input value={filterSearch} onChange={(q) => setFilterSearch(q.target.value)} onPressEnter={onFilterDataList} style={{ width: '40%' }} />
                <Button type='primary' onClick={onFilterDataList}>검색</Button>
            </div>} />

            <InlineContent title="유형" content={<div>
                <Radio.Group value={filterType} onChange={q => setFilterType(q.target.value)}>
                    <Radio value="all">전체</Radio>
                    <Radio value="feed">게시글</Radio>
                    <Radio value="feedComment">댓글</Radio>
                </Radio.Group>
            </div>} />
        </div>

        <div style={{ fontWeight: 700, marginBottom: '16px' }}>
            검색 결과({feedAndCommentClaimList.length})
        </div>
        <Table dataSource={feedAndCommentClaimList} columns={feedAndCommentClaimColumns} rowKey={'targetId'} loading={isLoading} pagination={{ showSizeChanger: true }} />
    </>
}

export default FeedAndCommentClaimManage